import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=39d59f20&scoped=true"
var script = {}
import style0 from "./FloatingButtons.vue?vue&type=style&index=0&id=39d59f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d59f20",
  null
  
)

export default component.exports